@if (entriesData && entriesData.length) {
  <ul>
    @for (item of entriesData; track item) {
      @for (elem of item[1]; track elem; let last = $last) {
<li [ngClass]="{
      'last': last,
      'proColor': item[0] === 'fieldPros',
      'neutralColor': item[0] === 'fieldNeutral',
      'conColor': item[0] === 'fieldCons'}">
      <icon aria-hidden="true" size="medium" bg="true" [glyph]="(item[0] === 'fieldPros' && 'arrow-up')
        || (item[0] === 'fieldNeutral' && 'minimize-2')
        || (item[0] === 'fieldCons' && 'arrow-down')"></icon>
          <span role="text">{{ elem }}</span>
        </li>
      }
    }
  </ul>
}
